import { render, staticRenderFns } from "./WorkflowCommentEdit.vue?vue&type=template&id=64f849ac&scoped=true"
import script from "./WorkflowCommentEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowCommentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f849ac",
  null
  
)

export default component.exports